import { isAxiosError } from 'axios';
import axiosInstance from '../../utility/axiosInstance';

// types and state
import {
  setCommunications,
  createCommunication,
  updateCommunication,
  setLoading,
  setUpdate
} from '@/store/slices/communication';
import { AppDispatch } from '@/store';

// notification
import { openNotification } from '@/components/alerts/notify';

export const get_communications = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get('/get-communications');

    dispatch(setCommunications(response.data));
  } catch (err) {
    if (isAxiosError(err)) dispatch(setCommunications([]));
  }
  dispatch(setLoading());
};

type ICreateData = { name: string };
export const create_communication = async (
  dispatch: AppDispatch,
  data: ICreateData
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.post('/create-communication', data);

    openNotification({ status: 'success', message: response.data?.message });
    dispatch(createCommunication(response.data?.data));
  } catch (err) {
    if (isAxiosError(err)) {
    }
  }
  dispatch(setUpdate());
};

type IUpdateData = { name: string; id: string };
export const update_communication = async (
  dispatch: AppDispatch,
  data: IUpdateData
) => {
  dispatch(setUpdate());
  try {
    const response = await axiosInstance.patch('/update-communication', data);

    openNotification({ status: 'success', message: response.data?.message });
    dispatch(updateCommunication(response.data?.data));
  } catch (err) {
    if (isAxiosError(err)) {
      openNotification({
        status: 'success',
        message: err?.response?.data?.message
      });
    }
  }
  dispatch(setUpdate());
};
